import { createFileRoute } from '@tanstack/react-router';
import { EmptyState } from '@/components/page-header';
import { TreeListPage } from '@/components/tracking/tree-list-page';
import { useOrgId } from '@/lib/org';

export const Route = createFileRoute('/settings/locations')({ component: Locations });

/** Screen L2 (document 06): locations, under the company's location label. */
function Locations() {
  const orgId = useOrgId();
  if (!orgId) return <EmptyState title="Select a client" />;
  return <TreeListPage kind="locations" />;
}
